import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Circle from '../circle';
import Icon from '@material-ui/core/Icon';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

export default class Presentation extends React.Component{
  componentDidMount(){
    if(this.line){
      this.set();
    }
  }

  set(){
    var self = this;
    var d = 3500;
    var e = 'easeInOutQuint';
    anime({
      targets: self.top,
      left: ['40%', '60%'],
      opacity: [0, 1],
      duration: d,
      easing: e
    })
    anime({
      targets: self.bottom,
      left: ['55%', '40%'],
      opacity: [0, 1],
      duration: d,
      easing: e,
      complete: function(){
        self.finish();
      }
    })
    self.prefinish();
  }
  prefinish(){
    var self = this;
    var d = 1000;
    var e = 'easeInOutQuint';
    anime({
      targets: self.line,
      opacity: [0, 1],
      duration: d,
      left: ['70%', '50%'],
      easing: e,
      delay: 1200,
      complete: function(){
      }
    })
  }
  finish(){
    var self = this;
    var d = 1000;
    var e = 'linear';
    anime({
      targets: self.container,
      opacity: 0,
      duration: d,
      easing: e,
      complete: function(){
        self.props.onFinish();
      }
    })
  }

  render(){
    return null;
    return(
      <div id="presentation" ref={(ref) => this.container = ref}>
        <div
          className="presentation_b_s"
          style={{backgroundImage: 'url('+ require('../../static/p_1.png') +')'}}
          ref={(ref) => this.line = ref}
        />
        <div
          className="presentation_b_s presentation_clear"
          style={{backgroundImage: 'url('+ require('../../static/p_2.png') +')'}}
          ref={(ref) => this.top = ref}
        />
        <div
          className="presentation_b_s presentation_clear"
          style={{backgroundImage: 'url('+ require('../../static/p_3.png') +')'}}
          ref={(ref) => this.bottom = ref}
        />
      </div>
    )
  }
}
